import { render, staticRenderFns } from "./mtd-category-tree.vue?vue&type=template&id=06028d49&"
import script from "./mtd-category-tree.vue?vue&type=script&lang=ts&"
export * from "./mtd-category-tree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports